import { Dimensions } from "react-native";

export const smallScreen = Dimensions.get("window").height < 700;
